import {useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import EmailEditor, {TemplatePurposes, TemplateTypes} from './EmailEditor';
import {CCInput} from './CCInput';
import {User} from '@/Auth/User';

export default function EmailEditorDialog({
    open,
    onClose,
    onSend,
    templateType,
    templateData,
    currentEmails,
    templatePurpose,
}: {
    open: boolean;
    onClose: any;
    onSend: any;
    templateType: TemplateTypes;
    templateData: any[];
    currentEmails: string[];
    templatePurpose: TemplatePurposes;
}) {
    const [toEmails, setToEmails] = useState([...Array.from(new Set(currentEmails))]);
    const [bccEmails, setBccEmails] = useState([...Array.from(new Set(currentEmails))]);

    return (
        <Dialog disableEnforceFocus={true} maxWidth={false} open={open} onClose={onClose} style={{zIndex: 1300}}>
            {/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
            <DialogContent style={{height: '90vh', minHeight: 600}}>
                <CCInput initialEmails={Array.from(new Set(currentEmails))} type="To" setEmails={setToEmails} />
                <CCInput initialEmails={[User.Info.email]} type="From" />
                <CCInput initialEmails={[User.Info.email]} type="BCC" setEmails={setBccEmails} />
                <EmailEditor
                    onSend={onSend}
                    emails={toEmails}
                    bccEmails={bccEmails}
                    templatePurpose={templatePurpose}
                    templateType={templateType}
                    templateData={templateData}
                ></EmailEditor>
            </DialogContent>
        </Dialog>
    );
}
